"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ZonepartsModel = /** @class */ (function () {
    function ZonepartsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.extract = this.extract.bind(this);
    }
    ZonepartsModel.prototype.extract = function (result) {
        return result.data;
    };
    /**
     * Get all zoneparts for a school
     */
    ZonepartsModel.prototype.getZoneparts = function (schoolId) {
        var _this = this;
        return this.$http
            .get("".concat(this.APPURL, "/api/v1/schools/").concat(schoolId, "/zoneparts"))
            .then(function (result) { return _this.extract(result).zoneparts; });
    };
    /**
     * Get a single zonepart
     */
    ZonepartsModel.prototype.getZonepart = function (schoolId, zonepartId) {
        var _this = this;
        return this.$http
            .get("".concat(this.APPURL, "/api/v1/schools/").concat(schoolId, "/zoneparts/").concat(zonepartId))
            .then(function (result) { return _this.extract(result).zonepart; });
    };
    /**
     * Update a zonepart's properties (name, zone_id, geometry)
     */
    ZonepartsModel.prototype.updateZonepart = function (schoolId, zonepartId, data) {
        var _this = this;
        return this.$http
            .put("".concat(this.APPURL, "/api/v1/schools/").concat(schoolId, "/zoneparts/").concat(zonepartId), data)
            .then(function (result) { return _this.extract(result).zonepart; });
    };
    /**
     * Update only the geometry of a zonepart
     */
    ZonepartsModel.prototype.updateZonepartGeometry = function (schoolId, zonepartId, geometry) {
        return this.updateZonepart(schoolId, zonepartId, { geometry: geometry });
    };
    /**
     * Move a zonepart to a different zone
     */
    ZonepartsModel.prototype.moveZonepartToZone = function (schoolId, zonepartId, zoneId) {
        return this.updateZonepart(schoolId, zonepartId, { zone_id: zoneId });
    };
    /**
     * Validate GeoJSON geometry
     */
    ZonepartsModel.prototype.validateGeometry = function (geometry) {
        if (!geometry || typeof geometry !== "object") {
            return false;
        }
        var geo = geometry;
        var validTypes = ["Polygon", "MultiPolygon"];
        if (!geo.type || !validTypes.includes(geo.type)) {
            return false;
        }
        if (!Array.isArray(geo.coordinates)) {
            return false;
        }
        // Basic coordinate validation
        if (geo.type === "Polygon") {
            return geo.coordinates.every(function (ring) {
                return Array.isArray(ring) &&
                    ring.length >= 4 &&
                    ring.every(function (coord) {
                        return Array.isArray(coord) &&
                            coord.length === 2 &&
                            typeof coord[0] === "number" &&
                            typeof coord[1] === "number";
                    });
            });
        }
        else if (geo.type === "MultiPolygon") {
            return geo.coordinates.every(function (polygon) {
                return Array.isArray(polygon) &&
                    polygon.every(function (ring) {
                        return Array.isArray(ring) &&
                            ring.length >= 4 &&
                            ring.every(function (coord) {
                                return Array.isArray(coord) &&
                                    coord.length === 2 &&
                                    typeof coord[0] === "number" &&
                                    typeof coord[1] === "number";
                            });
                    });
            });
        }
        return false;
    };
    /**
     * Convert geometry to GeoJSON Feature for map display
     */
    ZonepartsModel.prototype.toGeoJSONFeature = function (zonepart) {
        var _a;
        if (!zonepart.geometry) {
            return null;
        }
        return {
            type: "Feature",
            id: zonepart.id,
            properties: {
                id: zonepart.id,
                name: zonepart.name,
                zone_id: zonepart.zone_id,
                zone_name: (_a = zonepart.zone) === null || _a === void 0 ? void 0 : _a.name,
            },
            geometry: zonepart.geometry,
        };
    };
    /**
     * Convert array of zoneparts to GeoJSON FeatureCollection
     */
    ZonepartsModel.prototype.toGeoJSONFeatureCollection = function (zoneparts) {
        var _this = this;
        var features = zoneparts
            .map(function (zp) { return _this.toGeoJSONFeature(zp); })
            .filter(function (f) { return f !== null; });
        return {
            type: "FeatureCollection",
            features: features,
        };
    };
    return ZonepartsModel;
}());
ZonepartsModel.$inject = ["$http", "APPURL"];
exports.default = ZonepartsModel;
